import React from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const InfoTooltip = ({ title }) => {
  return (
    <Tooltip title={title} color="#1890ff">
      <InfoCircleOutlined style={{ fontSize: 10, color: "#1E88E5" }} />
    </Tooltip>
  );
};

export default InfoTooltip;
